import React, { useState, useRef, useEffect } from "react";
import ProgramsListItem from "./ProgramsListItem";
import {
  ProgramsListSectionContainer,
  FolderName,
  FolderPrograms,
  FolderContainer,
  DropdownItems,
  DropdownButton,
  ButtonContainer,
  TableActions,
  FolderNameInputField,
} from "./styles";
import Icon from "../../../../../common/Icon";
import { Context } from "../../../../../Store";
import callAPI from "../../../../../api/apiCaller";
import { setProgramListAsLoading } from "../../../../../Store/ProgramsList/actions";

function ProgramsListSection({
  setProgramList,
  folder,
  programs,
  moveProgram,
  searchText,
  setHamburgerOpen,
  hamburgerOpen,
  closeOnClick,
}) {
  const inputRef = useRef(null);

  const { state, dispatch } = React.useContext(Context);
  const [showHidePrograms, setShowHidePrograms] = useState(false);

  const showHideHandler = () => {
    setShowHidePrograms(!showHidePrograms);
  };

  /******** Rename Folder *****/
  const [showDropdown, setShowDropdown] = useState(false);
  const [editProgram, setEditProgram] = useState(false);
  const [folderName, setFolderName] = useState(folder !== "" ? folder : "");

  // const onEditHandler = () => {
  //   inputRef.current?.focus();

  //   setEditProgram(true);
  //   // Hide dropdown
  //   setShowDropdown(false);
  // };
  useEffect(() => {
    if (editProgram) {
      inputRef.current?.focus();
    }
  }, [editProgram]);

  const onEditHandler = () => {
    setEditProgram(true); // Triggers useEffect
    setShowDropdown(false); // Optional: hide dropdown
  };

  const closeEditHandler = () => {
    setEditProgram(false);
  };

  const onChangeHandler = (event) => {
    const { value } = event.target;

    setFolderName(value);
  };

  function getPrograms() {
    dispatch(setProgramListAsLoading());
    callAPI(dispatch, "fetchPrograms").then((programs) => {
      dispatch(setProgramList(programs.data));
    });
  }

  const renameFolderHandler = (event) => {
    if (event.key === "Enter") {
      dispatch(setProgramListAsLoading());
      return callAPI(dispatch, "renameFolder", {
        oldName: folder,
        title: folderName,
      }).then(() => {
        getPrograms();
      });
    }
  };

  const deleteFolderHandler = () => {
    return callAPI(dispatch, "deleteFolder", {
      title: folder,
    }).then(() => {
      dispatch(setProgramListAsLoading());
      getPrograms();
    });
  };
  /******** Rename Folder *****/

  return (
    <ProgramsListSectionContainer
      onDrop={(e) => {
        e.preventDefault();
        moveProgram(e.dataTransfer.getData("text"), folder);
      }}
      onDragOver={(e) => {
        e.preventDefault();
      }}
    >
      {folder != "" && (
        <FolderContainer>
          {editProgram ? (
            // <OutsideClickHandler onOutsideClick={closeEditHandler}>
            <FolderNameInputField
              ref={inputRef}
              onChange={onChangeHandler}
              value={folderName}
              // disabled={folderName.length > 28}
              onKeyDown={renameFolderHandler}
            />
          ) : (
            // </OutsideClickHandler>
            <FolderName isBlack={true}>{folder}</FolderName>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "12px",
              alignItems: "center",
            }}
          >
            <TableActions>
              <ButtonContainer
                onMouseEnter={() => setShowDropdown(true)}
                onMouseLeave={() => setShowDropdown(false)}
              >
                <Icon type={"vertical-dots"} />
                {showDropdown && (
                  <DropdownItems>
                    <DropdownButton meetings={true} onClick={onEditHandler}>
                      <Icon type={"edit"} />
                      Edit Folder
                    </DropdownButton>

                    <DropdownButton
                      meetings={true}
                      variant="secondary"
                      onClick={deleteFolderHandler}
                    >
                      <Icon type={"trash"} />
                      Delete
                    </DropdownButton>
                  </DropdownItems>
                )}
              </ButtonContainer>
            </TableActions>

            <ButtonContainer onClick={showHideHandler}>
              <Icon type={!showHidePrograms ? "expand" : "collapse"} />
            </ButtonContainer>
          </div>
        </FolderContainer>
      )}
      {((folder === "" && !showHidePrograms) ||
        (folder !== "" && showHidePrograms)) && (
        <FolderPrograms>
          {programs.programs
            .filter(
              (program) =>
                searchText === "" ||
                program.title.toLowerCase().includes(searchText.toLowerCase())
            )
            .map((program) => (
              <ProgramsListItem
                key={program.id}
                program={program}
                setHamburgerOpen={setHamburgerOpen}
                hamburgerOpen={hamburgerOpen}
                closeOnClick={closeOnClick}
                getPrograms={getPrograms}
              />
            ))}
        </FolderPrograms>
      )}
    </ProgramsListSectionContainer>
  );
}
export default ProgramsListSection;
